<div class="barcode-header bg-primary">
  <div class="qr-container bg-glass">
    <ng-container *ngIf="(barcode$ | async)?.Barcode as barcode; else loading">
      <div class="qr-code bg-white">
        <qrcode [qrdata]="barcode" [width]="125" [errorCorrectionLevel]="'M'" [elementType]="'svg'"></qrcode>
      </div>
      <p class="text-white font-size-12 text-center mb-0">{{ 'barcode.scan.info' | translate }}</p>
    </ng-container>
  </div>
</div>

<ng-template #loading>
  <fgbcl-loading [color]="'white'"></fgbcl-loading>
</ng-template>
